import React, { useState } from 'react';
import { ENGINEERING_GUIDES, EngineeringGuide } from '../data/guidesData';

export const EngineeringGuides: React.FC = () => {
  const [activeGuide, setActiveGuide] = useState<EngineeringGuide | null>(null);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div>
        <span className="text-xs font-bold uppercase tracking-wider text-[#087F9C] block mb-1">
          Technical Knowledge Base
        </span>
        <h1 className="font-display font-extrabold text-3xl sm:text-4xl text-[#10283D]">
          Pipe Sizing Engineering Guides
        </h1>
        <p className="text-slate-600 text-sm mt-1 max-w-3xl">
          Peer-reviewed guides covering fluid mechanics, British and American plumbing codes, velocity limits, and pressure drop equations.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {ENGINEERING_GUIDES.map((g) => (
          <div
            key={g.id}
            onClick={() => setActiveGuide(g)}
            className="bg-white p-6 rounded-3xl border border-slate-200 shadow-xs flex flex-col justify-between calc-card cursor-pointer"
          >
            <div>
              <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-teal-50 text-[#087F9C]">
                {g.tag}
              </span>
              <h3 className="font-display font-bold text-base text-[#10283D] mt-2">{g.title}</h3>
              <p className="text-xs text-slate-600 mt-2 line-clamp-3 leading-relaxed">{g.summary}</p>
            </div>
            <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between text-xs font-semibold text-[#087F9C]">
              <span>Read Complete Article →</span>
              <span className="text-slate-400 font-normal">5 min read</span>
            </div>
          </div>
        ))}
      </div>

      {/* Guide Reader Modal */}
      {activeGuide && (
        <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-xs flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl max-w-3xl w-full max-h-[85vh] overflow-y-auto p-6 sm:p-8 shadow-2xl space-y-4">
            <div className="flex items-center justify-between border-b border-slate-100 pb-3">
              <span className="text-xs font-bold px-2 py-0.5 rounded-full bg-teal-50 text-[#087F9C]">
                {activeGuide.tag}
              </span>
              <button
                onClick={() => setActiveGuide(null)}
                className="text-slate-400 hover:text-slate-700 font-bold text-lg p-1"
              >
                ✕
              </button>
            </div>
            <h2 className="font-display font-extrabold text-2xl text-[#10283D]">
              {activeGuide.title}
            </h2>
            <div
              className="text-sm text-slate-700 leading-relaxed space-y-3"
              dangerouslySetInnerHTML={{ __html: activeGuide.content }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
